import React, { useContext, useEffect, useRef } from 'react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import Link from '@/components/atoms/link';
import { useTranslations } from 'use-intl';
import { HeaderContext } from '../context';

export const CartIcon = ({ onClick, cartItems, className }: { cartItems: number, onClick: any, className: string }) => {
  const cartIcon = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (cartIcon.current) {
      const width = cartIcon.current.offsetWidth || 28;
      cartIcon.current.style.height = `${width}px`;
      const position = width / 2 + (0.1 * width);
      cartIcon.current.style.right = `-${position}px`;
      cartIcon.current.style.top = `-${position}px`;
    }
  }, [cartItems]);
  

  return <div className={className} onClick={onClick} >
    <svg style={{ width: "26px", height: "26px" }} xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
      <path d="M7 7H13.4444L14.7333 13.4444M19.8889 39.2222H52.1111L65 13.4444H14.7333M19.8889 39.2222L14.7333 13.4444M19.8889 39.2222L12.5007 46.6104C10.4708 48.6403 11.9084 52.1111 14.7791 52.1111H52.1111M52.1111 52.1111C48.5519 52.1111 45.6667 54.9964 45.6667 58.5556C45.6667 62.1147 48.5519 65 52.1111 65C55.6703 65 58.5556 62.1147 58.5556 58.5556C58.5556 54.9964 55.6703 52.1111 52.1111 52.1111ZM26.3333 58.5556C26.3333 62.1147 23.4481 65 19.8889 65C16.3297 65 13.4444 62.1147 13.4444 58.5556C13.4444 54.9964 16.3297 52.1111 19.8889 52.1111C23.4481 52.1111 26.3333 54.9964 26.3333 58.5556Z" stroke="#666666" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    {cartItems > 0 &&
      <div ref={cartIcon} className="flex items-center justify-center absolute" style={{ background: "red", minHeight: "100%", minWidth: "100%", borderRadius: "100%", color: "white", fontSize: "15px", fontWeight: 500, right: "-50%", top: "-50%", padding: "2px" }}
      >
        {cartItems}
      </div>}
  </div>
}

const CartLink = () => {
  const translate = useTranslations();
  const { cartLink, cartItems } = useContext(HeaderContext);
  return (
    <Link link={cartLink.href ?? '/'} className="relative flex items-center justify-center p-1">
      {cartItems > 0 && (
        <p className="absolute -right-2 top-[-14px] rounded-full bg-primary px-[5px] py-[2px] text-10 text-white lg:right-[-12px]">
          {cartItems.toString()}
        </p>
      )}
      <p className="hidden text-16 text-gray-700 lg:block">{translate('common.cart')}</p>
      <ShoppingCartIcon className="ml-0 w-6 text-gray-700 lg:ml-2 lg:w-5" />
    </Link>
  );
};
export default CartLink;
